module.exports = __webpack_public_path__ + "img/wilki_1.c27d73c6.jpg";